<template>
  <div class="dash-text__16 dash-text__500 base_menu">
    <router-link
      v-for="(item, index) in _modules"
      :key="item.id"
      :animated="true"
      v-bind:style="{
        marginRight: index !== _modules.length - 1 ? '100px' : 0,
      }"
      v-bind:class="{
        'demo__Router--active': module === item.id && $route.path !== '/',
      }"
      slot="tab"
      class="demo__Router demo__font--16 demo__weight--600"
      :to="item.url"
    >
      <span class="v-a-m">{{ $t(item.id) }}</span>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    windowWidth: {
      required: true,
      type: Number,
    },
  },
  computed: {
    ...mapGetters(["module", "modules"]),
    _modules() {
      return this.modules.filter((module) => {
        return !module.hide;
      });
    },
  },
  created() {
    this.$accessModule("menu_component", this);
  },
};
</script>
